<template>
  <div class="modal-column">
    <div class="modal-column-full-body">
      <Form ref="form" mode="block" :rules="{}" :model="formData">
        <template v-if="category==='未开具发票'">
          <div class="inline-form-item">
            <FormItem label="开票日期" required prop="tradeDate">
              <DatePicker v-model="formData.tradeDate" :clearable="false"/>
            </FormItem>
            <FormItem label="客户名称" prop="customerName">
              <Input required v-model="formData.customerName"/>
            </FormItem>
            <FormItem label="统一社会信用代码" prop="creditCode">
              <Input v-model="formData.creditCode"/>
            </FormItem>
          </div>
          <FormItem label="备注" prop="note">
            <Input v-model="formData.note"/>
          </FormItem>
        </template>
        <template v-else>
          <div class="inline-form-item">
            <FormItem label="开票日期" required prop="tradeDate">
              <DatePicker :readonly="readonly" :disabled="readonly" v-model="formData.tradeDate"  :clearable="false"/>
            </FormItem>
            <FormItem label="数电票代码"  prop="electricInvoiceCode">
              <Input required :readonly="readonly" v-model="formData.electricInvoiceCode"/>
            </FormItem>
            <FormItem label="发票代码"  prop="invoiceCode">
              <Input required :readonly="readonly" v-model="formData.invoiceCode"/>
            </FormItem>
            <FormItem label="发票号码"  prop="invoiceNumber">
              <Input :readonly="readonly" v-model="formData.invoiceNumber"/>
            </FormItem>
          </div>
          <div class="inline-form-item">
            <FormItem label="是否作废" required>
              <Radio :disabled="readonly" v-model="formData.state" :datas="['正常','作废','红冲']"/>
            </FormItem>
            <FormItem label="客户名称" v-if="type==='OUT'">
              <Input :readonly="readonly" v-model="formData.customerName"/>
            </FormItem>
            <FormItem v-else label="供应商名称" prop="customerName" required>
              <Input :readonly="readonly" v-model="formData.customerName"/>
            </FormItem>
            <FormItem label="统一社会信用代码">
              <Input :readonly="readonly" v-model="formData.creditCode"/>
            </FormItem>
          </div>
          <div class="inline-form-item">
            <FormItem label="地址及电话">
              <Input :readonly="readonly" v-model="formData.address"/>
            </FormItem>
            <FormItem label="开户行及账号">
              <Input :readonly="readonly" v-model="formData.account"/>
            </FormItem>
            <FormItem label="备注">
              <Input maxlength="255" :readonly="readonly" v-model="formData.note"/>
            </FormItem>
          </div>
          <div class="inline-form-item" v-if="category==3 || category==4">
            <FormItem label="车辆类型">
              <Input :readonly="readonly" v-model="formData.vehicleType"/>
            </FormItem>
            <FormItem label="厂牌型号">
              <Input :readonly="readonly" v-model="formData.factoryModel"/>
            </FormItem>
            <FormItem label="车架号">
              <Input :readonly="readonly" v-model="formData.vehicleNum"/>
            </FormItem>
            <FormItem label="发动机号">
              <Input :readonly="readonly" v-model="formData.engineNum"/>
            </FormItem>
          </div>
        </template>
        <FormItem label="业务类型" prop="invoiceBusinessTypeId" required>
          <!-- 新增业务类型 -->
          <div style="display:flex;flex-direction:row;align-items:center;">
            <Select :disabled="readonly" :datas="businessList" keyName="id" :deletable="false" class="!w-200px" v-model="formData.invoiceBusinessTypeId"/>
            <Button icon="fa fa-plus" @click="showInvoiceVoucherTemplate"></Button>
            <p style="font-size:18px;margin-left:4px" @click="msg()"><i class="h-icon-help"></i></p>
          </div>
        </FormItem>
        <FormItem label="发票数据">
          <div class="flex mb-16px">
            <div class="flex flex-1">
              <span><i class="red-color">*</i>是否录入发票明细：</span>
              <Radio :disabled="readonly" v-model="formData.haveDetail" :datas="[{key:true,title:'是'},{key:false,title:'否'}]"></Radio>
            </div>
            <div class="flex flex-1 mx-16px">
              <span><i class="red-color">*</i>不含税金额：</span>
              <Input  :disabled="formData.haveDetail || readonly" class="flex-1" v-model.number="formData.taxAmountExcluded"/>
            </div>
            <div class="flex flex-1">
              <span><i class="red-color">*</i>税额：</span>
              <Input :disabled="formData.haveDetail || readonly" class="flex-1" v-model.number="formData.taxAmount"/>
            </div>
            <div class="flex flex-1 ml-16px">
              <span><i class="red-color">*</i>价税合计：</span>
              <Input disabled class="flex-1" v-model.number="formData.amount"/>
            </div>
          </div>
          <template v-if="formData.haveDetail">
            <vxe-table @cell-click="selectGoods" ref="itemsTable" :data="items" border :edit-config="{trigger:'click',mode:'row'}" :edit-rules="validConfig">
              <vxe-column width="80" align="center">
                <template #default="{row,rowIndex}">
                  <span @click="pushItem(row)" class="fa fa-plus mr-16px text-hover"/>
                  <span @click="popItem(row)" class="fa fa-minus red-color text-hover"/>
                </template>
              </vxe-column>
              <vxe-column field="goodsName" title="商品名称" :edit-render="{name:'$input',props:{readonly:readonly},events:{blur:goodsBlur}}"/>
              <vxe-column field="specification" title="规格" :edit-render="{name:'$input',props:{readonly:readonly}}"/>
              <vxe-column field="unit" title="单位" align="center" :edit-render="{name:'$input',props:{readonly:readonly}}"/>
              <vxe-column field="quantity" title="数量" align="right" :edit-render="{name:'$input',props:{type:'number',readonly:readonly}}"/>
              <vxe-column field="amount" title="金额" align="right" :edit-render="{name:'$input',props:{type:'number',readonly:readonly},events:{input:amountChange},immediate:true}"/>
              <vxe-column field="taxRate" title="税率" align="right" :edit-render="{name:'$select',props:{disabled:readonly},options:taxRateList,events:{change:amountChange}}"/>
              <vxe-column field="tax" title="税额" align="right" :edit-render="{name:'$input',props:{type:'number',readonly:readonly},events:{input:amountChangeTax}}"/>
              <vxe-column width="100" field="taxedItems" title="征税项目" :edit-render="{name:'$select',props:{disabled:readonly},options:taxedItems}"/>
              <vxe-column width="140" field="taxCalculationMethod" title="计税方法" :edit-render="{name:'$select',props:{disabled:readonly},options:taxCalculationMethod}"/>
            </vxe-table>
          </template>
        </FormItem>
      </Form>
    </div>
    <div class="modal-column-between">
      <vxe-button :loading="loading" @click="$emit('close')" v-if="!readonly" icon="fa fa-close">取消</vxe-button>
      <vxe-button :loading="loading" @click="doSubmit()" v-if="!readonly" status="primary" icon="fa fa-check">保存</vxe-button>
      <vxe-button :loading="loading" @click="$emit('close')" v-if="readonly" icon="fa fa-close">关闭</vxe-button>
    </div>
  </div>
</template>

<script>
import {TaxCalculationMethod, TaxedItems, TaxRateList} from "@/views/invoice/InvoiceData";
import NP from "number-precision";
import {Invoice, InvoiceBusiness} from "@/api/Invoice";
import {CopyObj} from "@/js/common/utils";
import {layer} from "@layui/layer-vue";
import {computed, h, ref} from "vue";
import InvoiceVoucherTemplate from "@/views/invoice/InvoiceVoucherTemplate";

/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
  name: "InvoiceForm",
  props: {
    entity: Object,
    type: String,
    category: String,
    readonly:Boolean
  },
  data() {
    return {
      loading: false,
      businessList: [],
      formData: {
        id: null,
        category: null,
        type: null,
        tradeDate: null,
        checkDate: null,
        invoiceCode: null,
        electricInvoiceCode: null,
        invoiceNumber: null,
        customerName: null,
        address: null,
        account: null,
        note: null,
        state: '正常',
        creditCode: null,
        invoiceBusinessTypeId: null,
        taxAmountExcluded: 0,
        taxAmount: 0,
        amount: 0,
        vehicleType: null,
        factoryModel: null,
        vehicleNum: null,
        engineNum: null,
        haveDetail: true
      },
      items: [],
      validConfig: {
        goodsName: [{
          required: true, message: "输入商品名称"
        }],
        amount: [{
          required: true, message: "输入金额"
        }],
        taxRate: [
          {
            required: true, message: "输选择税率"
          }
        ],
        tax: [
          {
            required: true, message: "输入税额"
          }
        ],
        taxedItems: [
          {
            required: true, message: "输选择征税项目"
          }
        ],
        taxCalculationMethod: [
          {
            required: true, message: "输选择计税方法"
          }
        ]
      },
      taxRateList: TaxRateList,
      taxedItems: TaxedItems,
      taxCalculationMethod: TaxCalculationMethod
    }
  },
  watch: {
    'formData.taxAmountExcluded'() {
      this.formData.amount = NP.round((this.formData.taxAmountExcluded || 0) + (this.formData.taxAmount || 0), 2);
    },
    'formData.taxAmount'() {
      this.formData.amount = NP.round((this.formData.taxAmountExcluded || 0) + (this.formData.taxAmount || 0), 2);
    }
  },
  methods: {
    msg(){
      this.$Message({
        type:'info',
        text: `业务类型就是发票生成凭证所绑定的模版。`
      });
    },
    //新增发票业务类型
    showInvoiceVoucherTemplate() {
      let layerId = layer.drawer({
				title: "凭证模板设置",
				shadeClose: false,
				zIndex: 1001,
				area: ['700px', '100vh'],
				content: h(InvoiceVoucherTemplate, {
					onSuccess: (args) => {
					},
          //这个关闭需要手动触发,当作参数传递
					onClose: (args) => {
						layer.close(layerId);
					}
				}),
        //这个关闭是组件监听事件
				onClose: (args) => {
					InvoiceBusiness.list(this.type).then(({data}) => {
            this.businessList = data;
            if (!this.entity) {
              this.formData.invoiceBusinessTypeId = data[0].id;
            }
          })
				}
			});
    },
    //下拉失去焦点
    goodsBlur() {
      console.log("失去焦点")
    },
    //下拉选商品jxd以后再做吧
    selectGoods(row) {
        // console.log(row)
        // console.log(row.column.title)
      if(row.column.title == '商品名称'){
        
      }
    },
    amountChange({row}) {
      let {fullData} = this.$refs.itemsTable.getTableData();
      if (row.amount) {
        row.tax = NP.round(row.amount * (row.taxRate / 100), 2);
      } else {
        row.tax = null;
      }
      this.formData.taxAmountExcluded = NP.round(fullData.reduce((c, r) => c + Number((r.amount || 0)), 0), 2);
      this.formData.taxAmount = NP.round(fullData.reduce((c, r) => c + Number((r.tax || 0)), 0), 2)
    },
    amountChangeTax({row}) {
      setTimeout(() => {
        let {fullData} = this.$refs.itemsTable.getTableData();
        this.formData.taxAmountExcluded = NP.round(fullData.reduce((c, r) => c + Number((r.amount || 0)), 0), 2);
        this.formData.taxAmount = NP.round(fullData.reduce((c, r) => c + Number((r.tax || 0)), 0), 2)
      },1000)
    },
    pushItem(row) {
      this.$refs.itemsTable.insertAt({taxRate: 13, taxedItems: '应税货物', taxCalculationMethod: '一般计税方法-一般', tax: null}, row);
    },
    popItem(row) {
      let {fullData} = this.$refs.itemsTable.getTableData();
      if (fullData.length > 1) {
        this.$refs.itemsTable.remove(row);
      }
    },
    async doSubmit() {
      let validResult = this.$refs.form.valid();
      let valid = true;
      if (this.formData.haveDetail) {
        valid = await this.itemsValidate();
      }

      if (!this.formData.taxAmountExcluded || this.formData.taxAmountExcluded<=0) {
        this.$Message({
          type:'warn',
          text: `不含税金额必须是大于0的正数`
        });
        return;
      }

      if (!this.formData.electricInvoiceCode && !this.formData.invoiceCode && !this.formData.invoiceNumber) {
        this.$Message({
          type:'warn',
          text: `数电票代码，发票代码，发票编号不能同时为空，至少填写一个!`
        });
        return;
      }

      if (validResult.result && valid) {
        let params = Object.assign({}, this.formData);
        if (this.formData.haveDetail) {
          let {fullData} = this.$refs.itemsTable.getTableData();
          params.items = fullData.filter(val => val.goodsName && val.amount);
          this.formData.haveDetail = !!params.items.length
        }
        this.loading = true;
        Invoice.save(params).then(() => {
          this.$emit('success')
        }).finally(() => this.loading = false);
      }
    },
    async itemsValidate() {
      return this.formData.taxAmountExcluded > 0;
    }
  },
  created() {
    this.formData.category = this.category;
    this.formData.type = this.type;
    InvoiceBusiness.list(this.type).then(({data}) => {
      this.businessList = data;
      if (!this.entity) {
        this.formData.invoiceBusinessTypeId = data[0].id;
      }
    })

    if (this.entity) {
      this.items = this.entity.items;
      CopyObj(this.formData, this.entity)
    } else {
      const items = [];
      const line = this.category === '未开具发票' ? 1 : 5;
      for (let i = 0; i < line; i++) {
        items.push({taxRate: 13, taxedItems: '应税货物', taxCalculationMethod: '一般计税方法-一般', tax: null});
      }
      this.items = items;
    }
  }
}
</script>
